import { getZordonClient } from "../clients/zordon.client.js";
export class ZordonService {
  http;
  constructor(args){
    this.http = args.http;
  }
  /**
   * @mutation
   */ async uncacheWebsite(websiteId) {
    await this.http.get(`/context/uncache/${websiteId}`);
  }
  async createChatbot(args) {
    const { url, businessName, hasIA } = args;
    let path = '/1.0/setup-genia';
    if (hasIA) {
      path += '?cliengoIA=true';
    }
    const response = await this.http.post(path, {
      url,
      businessName
    });
    return response.data;
  }
  async deleteChatbot(websiteId) {
    const response = await this.http.delete(`/1.0/chatbot-config/${websiteId}`);
    return response.data;
  }
  /**
   * @query
   */ async getFaqs(websiteId, searchQuery) {
    const faqsPromise = this.http.get(`/faqs/${websiteId}${searchQuery ? `?${searchQuery}` : ''}`);
    const categoriesPromise = this.http.get(`/faqs/${websiteId}/categories`);
    const [faqs, categories] = await Promise.all([
      faqsPromise,
      categoriesPromise
    ]);
    return {
      faqs: faqs.data,
      categories: categories.data.categories
    };
  }
  /**
   * @mutation
   */ async updateFaq(args) {
    const { websiteId, question } = args;
    const response = await this.http.put(`/faqs/${websiteId}/${question._id}`, question);
    return response.data;
  }
  /**
   * @mutation
   */ async deleteFaq(id, websiteId) {
    const response = await this.http.delete(`/faqs/${websiteId}/${id}`);
    return response.data;
  }
  /**
   * @mutation
   */ async resetKnowledge({ websiteId }) {
    const response = await this.http.delete(`/faqs/${websiteId}?all=true`);
    return response.data;
  }
  /**
   * @mutation
   */ async addFaq(args) {
    const { websiteId, question } = args;
    const response = await this.http.post(`/faqs/${websiteId}`, {
      faqs: [
        question
      ]
    });
    return response.data;
  }
  async getOnboardingState(companyId, creationDate) {
    const respose = await this.http.get(`/onboarding-state/${companyId}?creation-date=${creationDate}`);
    return respose.data;
  }
  async updateOnboardingState(companyId, lastCompletedStep) {
    const response = await this.http.put(`/onboarding-state/${companyId}`, {
      lastCompletedStep
    });
    return response.data;
  }
  async scrapUrlContent(url) {
    const response = await this.http.post('/1.0/scrap/content', {
      url
    });
    return response.data;
  }
  async scrapLinksFromUrl(url) {
    const response = await this.http.post('/1.0/scrap/linktree', {
      url
    });
    return response.data;
  }
  async getZordonConfig(websiteId) {
    const response = await this.http.get(`/1.0/chatbot-config/${websiteId}`);
    return response.data;
  }
  async createZordonConfig(data) {
    const response = await this.http.post('/1.0/chatbot-config', data);
    return response.data;
  }
  async deleteZordonConfig(websiteId) {
    const response = await this.http.delete(`/1.0/chatbot-config/${websiteId}`);
    return response.data;
  }
  async updateZordonConfigStrictMode(args) {
    const { websiteId, companyId, newValues } = args;
    const response = await this.http.put(`/1.0/chatbot-config/bot-profile/${websiteId}`, {
      newValues,
      companyId,
      websiteId
    });
    return response.data;
  }
  async updateZordonConfigBotProfile(args) {
    const { websiteId, companyId, newValues } = args;
    const response = await this.http.put(`/1.0/chatbot-config/bot-profile/${websiteId}`, {
      newValues,
      companyId,
      websiteId
    });
    return response.data;
  }
  async getZordonConfigKnowledgeSources(websiteId) {
    const response = await this.http.get(`/1.0/chatbot-config/knowledge-sources/${websiteId}`);
    return response.data;
  }
  async createZordonConfigKnowledgeSources(websiteId, knowledgeValues) {
    const response = await this.http.post(`/1.0/chatbot-config/knowledge-sources/${websiteId}`, {
      knowledgeValues
    });
    return response.data;
  }
  async updateZordonconfigKnowledgeSources(websiteId, newKnowledgeValues) {
    const response = await this.http.put(`/1.0/chatbot-config/knowledge-sources/${websiteId}`, {
      newKnowledgeValues
    });
    return response.data;
  }
  async updateZordonConfigCustomProperties(websiteId, customProperties) {
    const response = await this.http.put(`/1.0/chatbot-config/custom-properties/${websiteId}`, {
      customProperties
    });
    return response.data;
  }
  async getZordonConfigSteps(websiteId) {
    const response = await this.http.get(`/1.0/chatbot-config/steps/${websiteId}`);
    return response.data;
  }
  async updateZordonConfigSteps(websiteId, steps) {
    const response = await this.http.put(`/1.0/chatbot-config/steps/${websiteId}`, {
      steps
    });
    return response.data;
  }
}
export const getZordonService = (args)=>{
  const client = getZordonClient(args || {});
  return new ZordonService({
    http: client
  });
};
//# sourceMappingURL=zordon.service.js.map